import { FC } from 'react';
import classNames from 'classnames';
import {
  centeredButtonFields,
  getSlicePadding,
  toCtaButtonPropsFromItem,
} from '@/utils';
import { useShowByLocationSlug } from '@/hooks';
import { CenteredButtonSlice } from '@/types';
import { CtaButton } from '@/components';
import styles from './centeredbutton.module.scss';

const CenteredButton: FC<CenteredButtonSlice> = slice => {
  const { showContent } = useShowByLocationSlug(slice?.primary?.location_slug);

  const marginBottom = slice?.primary?.bottom_spacing;
  const paddingSection = slice?.primary?.padding_section;

  if (!slice?.primary?.active || !showContent) {
    return null;
  }

  const cta = toCtaButtonPropsFromItem(
    slice.primary ?? {},
    centeredButtonFields,
    'primary',
  );

  if (!cta) {
    return null;
  }

  return (
    <section
      className={classNames(styles.container, getSlicePadding(paddingSection), {
        ['spacing_bottom']: marginBottom,
      })}
    >
      <CtaButton
        {...cta}
        className={classNames(styles.cta, {
          [styles.cta_fit]: cta.fitContent,
        })}
      />
    </section>
  );
};

export default CenteredButton;
